import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import CustomersTable from './_CustomersTable.js';
import EditCustomer from './_EditCustomer.js';
const URI = ApiEndpoint + 'administration/';

const Customers = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [customers, setCustomers] = useState(false);
  const [idCustomerToEdit, setIdCustomerToEdit] = useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getCustomers();
  };
  const getCustomers = async () => {
    console.log('entre a getCustomers');
    setCustomers(null);

    httpClient('GET', URI + 'customers/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setCustomers(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getCustomers();
  }, []);
  return (
    <>
      {customers && (
        <CustomersTable
          customers={customers}
          setIdCustomerEdit={setIdCustomerToEdit}
          setOpenModal={setOpenModal}
        ></CustomersTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={(idCustomerToEdit > 0 ? 'Editar' : 'Agregar') + ' Cliente'}
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditCustomer
            idCustomer={idCustomerToEdit}
            closeModal={handleClose}
          ></EditCustomer>
        </MyModal>
      )}
    </>
  );
};

export default Customers;
